import React from 'react'
import PropTypes from 'prop-types'

import * as S from './styles'

function AdOverlay({ children }) {
  return <S.Overlay>{children}</S.Overlay>
}

AdOverlay.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.object,
  ]).isRequired,
}

export default AdOverlay
